export default __webpack_public_path__ + "static/media/logo.34e4446e.svg";